import { LOGIN_CHANGE_LOGIN_TYPE } from '../../constants/action_types';
import { changeFlow } from '../flow';
import { changePassword } from '../authentication';
export function changeLogin(login) {
  return function (dispatch, getState) {
    dispatch({
      type: LOGIN_CHANGE_LOGIN_TYPE,
      login: login
    });

    var _getState = getState(),
        activeFlow = _getState.activeFlow,
        password = _getState.authentication.password;

    if (activeFlow) {
      dispatch(changeFlow(null));

      if (password !== '') {
        dispatch(changePassword(''));
      }
    }
  };
}